module.exports = __webpack_public_path__ + "static/media/all-day-breakfast-hero-desktop.a109de6d.jpg";